<template>
  <div class="integralEdit seller-style">
    <h2 class="f18 fb normal gray_2">{{ ruleDtl.pointsType == 1 ? "发放规则设置" : "使用规则设置" }}</h2>
    <div class="box30"></div>
    <div class="flex mar30_b" v-if="ruleDtl.pointsType == 1">
      <div class="pad30_lr label">适用客户:</div>
      <el-radio-group v-model="ruleDtl.applyCustomerType" @change="getCustomerType()">
        <el-radio :label="3">
          <span>按指定客户</span>
          <div v-if="ruleDtl.applyCustomerType === 3" class="rule_clientType pad15_t">
            <el-button type="primary" class="mar10_l" @click="openCustomerPop()">添加</el-button>
            <div class="box20"></div>
            <el-table :data="customerPop.customerSelList" style="width: 100%">
              <el-table-column prop="name" label="客户名称" width="300"> </el-table-column>
              <el-table-column prop="phone" width="260" label="联系电话"> </el-table-column>
              <el-table-column prop="groupName" label="分组名称"> </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <span class="blue cursor" @click="removeSelectCustomer(scope.row)">删除</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-radio>
        <el-radio :label="2">
          <span>按客户分组</span>
          <div v-if="ruleDtl.applyCustomerType === 2" class="mar30_l">
            <el-checkbox-group v-model="ruleDtl.applyCustomerAttr" size="small" class="flex flex_wrap">
              <el-checkbox class="mar15_t" :label="group.id" border v-for="group in customerPop.groupDataList" v-bind:key="group.id">
                {{ group.name }}
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </el-radio>
        <el-radio :label="1">
          <span>所有人群</span>
        </el-radio>
      </el-radio-group>
    </div>
    <div class="flex">
      <div class="pad30_lr">规则详情:</div>
      <el-radio-group v-model="ruleDtl.busType" @change="busTypeChange">
        <el-radio :label="1">
          <span>{{ ruleDtl.pointsType == 1 ? "根据订单发放" : "根据订单使用" }}</span>
        </el-radio>
        <el-radio-group v-model="ruleDtl.ruleType" @change="ruleTypeChange" class="mar30_l">
          <el-radio :label="2">
            <span>订单每满</span>
            <el-input
              v-model="ruleDtl.ruleKey2"
              @input="ruleDtl.ruleKey2 = formatNums(ruleDtl.ruleKey2, true)"
              :disabled="ruleDtl.ruleType !== 2 || ruleDtl.busType !== 1"
            ></el-input>
            <span>元，{{ ruleDtl.pointsType == 1 ? "发放" : "可使用" }}</span>
            <el-input
              v-model="ruleDtl.ruleValue2"
              @input="ruleDtl.ruleValue2 = formatNums(ruleDtl.ruleValue2, true)"
              :disabled="ruleDtl.ruleType !== 2 || ruleDtl.busType !== 1"
            ></el-input>
            <span>{{ ruleDtl.name }}</span>
          </el-radio>
          <el-radio :label="3">
            <span>每笔订单{{ ruleDtl.pointsType == 1 ? "发放" : "使用" }}订单金额的</span>
            <el-input
              v-model="ruleDtl.ruleValue3"
              @input="ruleDtl.ruleValue3 = formatNums(ruleDtl.ruleValue3, true)"
              :disabled="ruleDtl.ruleType !== 3 || ruleDtl.busType !== 1"
            ></el-input>
            <span>%</span>
          </el-radio>
        </el-radio-group>
        <el-radio :label="4" v-if="ruleDtl.pointsType == 1">
          <span>根据评论发放 </span>
          <span>每个好评评论字数达到</span>
          <el-input v-model="ruleDtl.ruleKey4" @input="ruleDtl.ruleKey4 = formatNums(ruleDtl.ruleKey4, true)" :disabled="ruleDtl.busType !== 4"></el-input>
          <span>字，发放</span>
          <el-input
            v-model="ruleDtl.ruleValue4"
            @input="ruleDtl.ruleValue4 = formatNums(ruleDtl.ruleValue4, true)"
            :disabled="ruleDtl.busType !== 4"
          ></el-input>
          <span>{{ ruleDtl.name }}</span>
        </el-radio>
        <el-radio :label="2">
          <span>{{ ruleDtl.pointsType == 1 ? "根据商品发放" : "根据商品使用" }}</span>
          <div v-if="ruleDtl.busType === 2" class="mar30_l mar15-t rule_goodType">
            <el-radio-group v-model="ruleDtl.goodRuleType">
              <el-radio :label="1">
                <span>每种商品成功交易</span>
                <el-input
                  v-model="ruleDtl.goodRuleKey1"
                  @input="ruleDtl.goodRuleKey1 = formatNums(ruleDtl.goodRuleKey1, true)"
                  :disabled="ruleDtl.goodRuleType !== 1 || ruleDtl.busType !== 2"
                ></el-input>
                <span>件，{{ ruleDtl.pointsType == 1 ? "发放" : "使用" }}</span>
                <el-input
                  v-model="ruleDtl.goodRuleValue1"
                  @input="ruleDtl.goodRuleValue1 = formatNums(ruleDtl.goodRuleValue1, true)"
                  :disabled="ruleDtl.goodRuleType !== 1 || ruleDtl.busType !== 2"
                ></el-input>
                <span>{{ ruleDtl.name }}</span>
              </el-radio>
              <el-radio :label="2">
                <span>每种商品每成功交易</span>
                <el-input
                  v-model="ruleDtl.goodRuleKey2"
                  @input="ruleDtl.goodRuleKey2 = formatNums(ruleDtl.goodRuleKey2, true)"
                  :disabled="ruleDtl.goodRuleType !== 2 || ruleDtl.busType !== 2"
                ></el-input>
                <span>元，{{ ruleDtl.pointsType == 1 ? "发放" : "使用" }}</span>
                <el-input
                  v-model="ruleDtl.goodRuleValue2"
                  @input="ruleDtl.goodRuleValue2 = formatNums(ruleDtl.goodRuleValue2, true)"
                  :disabled="ruleDtl.goodRuleType !== 2 || ruleDtl.busType !== 2"
                ></el-input>
                <span>{{ ruleDtl.name }}</span>
              </el-radio>
              <el-radio :label="3">
                <span>每件商品，{{ ruleDtl.pointsType == 1 ? "发放" : "使用" }}订单中该商品金额的</span>
                <el-input
                  v-model="ruleDtl.goodRuleValue3"
                  @input="ruleDtl.goodRuleValue3 = formatNums(ruleDtl.goodRuleValue3, true)"
                  :disabled="ruleDtl.goodRuleType !== 3 || ruleDtl.busType !== 2"
                ></el-input>
                <span>%</span>
              </el-radio>
            </el-radio-group>
            <div class="add_good">
              <p class="gray6">添加货品</p>
              <div class="box10"></div>
              <el-radio-group v-model="ruleDtl.goodType">
                <el-radio :label="1">
                  <span>全部商品</span>
                </el-radio>
                <el-radio :label="2">
                  <span>指定商品</span>
                </el-radio>
              </el-radio-group>
              <div v-if="ruleDtl.goodType === 2">
                <el-button type="primary" class="mar10_l" @click="selectGoodsList('shop')">添加商品</el-button>
                <el-button type="primary" class="mar10_l" @click="selectGoodsList('dealer')">添加代销商品</el-button>
                <div class="box20"></div>
                <el-table :data="checkGoodsList" style="width: 100%">
                  <el-table-column prop="name" label="商品名称" width="300"> </el-table-column>
                  <el-table-column prop="marketPriceStr" width="260" label="价格"> </el-table-column>
                  <el-table-column prop="statusName" label="状态"> </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <span class="blue cursor" @click="removeCheckGoods(scope.row.goodsId)">删除</span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </el-radio>
        <el-radio :label="5" v-if="ruleDtl.pointsType == 1">
          <span>累计发放</span>
          <span class="f12 gray9 mar30_l">按照用户符合条件的最高消费金额或最多商品件数进行发放</span>
          <div v-if="ruleDtl.busType === 5" class="mar30_l mar15-t gray6 rule_goodType">
            <div class="mar15_b">
              <span class="pad20_r">时间范围：</span>
              <el-date-picker
                v-model="ruleDtl.timeStr"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd HH:mm:ss"
                popper-class="seller-style"
                :default-time="['00:00:00', '23:59:59']"
              >
              </el-date-picker>
            </div>
            <el-radio-group v-model="ruleDtl.sbusType">
              <el-radio :label="1">
                <span>按消费金额发放</span>
                <template v-if="ruleDtl.sbusType === 1">
                  <div class="mar30_l mar10_t gray6" v-for="(item, index) in ruleDtl.subRuleAttrVal" :key="index">
                    <span>所选时间范围内累计消费满</span>
                    <el-input v-model="item.ruleKey"></el-input>
                    <span>元，发放</span>
                    <el-input v-model="item.ruleValue"></el-input>
                    <span>{{ ruleDtl.name }}</span>
                    <span v-if="ruleDtl.subRuleAttrVal.length !== index + 1" @click="delsubRuleAttrVal(item)" class="mar30_l blue">删除</span>
                    <span v-if="ruleDtl.subRuleAttrVal.length === index + 1" @click="addsubRuleAttrVal()" class="mar30_l c_nx_blue">添加</span>
                  </div>
                </template>
              </el-radio>
              <el-radio :label="2">
                <span>按商品发放</span>
                <template v-if="ruleDtl.sbusType === 2">
                  <div class="mar30_l mar10_t gray6" v-for="(item, index) in ruleDtl.subRuleAttrVal" :key="index">
                    <span>所选时间范围内商品成功交易</span>
                    <el-input v-model="item.ruleKey"></el-input>
                    <span>件，发放</span>
                    <el-input v-model="item.ruleValue"></el-input>
                    <span>{{ ruleDtl.name }}</span>
                    <span v-if="ruleDtl.subRuleAttrVal.length !== index + 1" @click="delsubRuleAttrVal(item)" class="mar30_l blue">删除</span>
                    <span v-if="ruleDtl.subRuleAttrVal.length === index + 1" @click="addsubRuleAttrVal()" class="mar30_l c_nx_blue">添加</span>
                  </div>
                </template>
              </el-radio>
            </el-radio-group>
            <div class="add_good">
              <p class="gray6">添加货品</p>
              <div class="box10"></div>
              <el-radio-group v-model="ruleDtl.goodType">
                <el-radio :label="1">
                  <span>全部商品</span>
                </el-radio>
                <el-radio :label="2">
                  <span>指定商品</span>
                </el-radio>
              </el-radio-group>
              <div v-if="ruleDtl.goodType === 2">
                <el-button type="primary" class="mar10_l" @click="selectGoodsList('shop')">添加商品</el-button>
                <el-button type="primary" class="mar10_l" @click="selectGoodsList('dealer')">添加代销商品</el-button>
                <div class="box20"></div>
                <el-table :data="checkGoodsList" style="width: 100%">
                  <el-table-column prop="name" label="商品名称" width="300"> </el-table-column>
                  <el-table-column prop="marketPriceStr" width="260" label="价格"> </el-table-column>
                  <el-table-column prop="statusName" label="状态"> </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <span class="blue cursor" @click="removeCheckGoods(scope.row.goodsId)">删除</span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </el-radio>
        <el-radio :label="6" v-if="ruleDtl.pointsType == 1 && ruleDtl.shopId == '6340867391440003296'">
          <span>社区激励</span>
          <div class="pad40-l gray3" v-if="ruleDtl.busType === 6">
            <div class="mar15_b pad10-t">
              <span class="pad20_r">时间范围：</span>
              <el-date-picker
                v-model="ruleDtl.timeStr"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
              >
              </el-date-picker>
            </div>
            <div class="pad10-t">
              <span>发帖</span>
              <span class="f12 gray9 mar30_l">帖子审核通过后，发帖者可得积分</span>
              <div v-for="subRuleAttr in ruleDtl.subRuleAttrList" :key="subRuleAttr.ruleSubType">
                <div class="pad20-l gray3 pad10-t" v-if="subRuleAttr.ruleSubType === 'FT_BY_OPERATOR'">
                  <span>发帖者获得</span>
                  <el-input
                    v-model="subRuleAttr.pointsGrantValue"
                    @input="subRuleAttr.pointsGrantValue = formatNums(subRuleAttr.pointsGrantValue, true)"
                  ></el-input>
                  <span>积分，每日奖励上限</span>
                  <el-input
                    v-model="subRuleAttr.ruleSubHandleLimitValue"
                    @input="subRuleAttr.ruleSubHandleLimitValue = formatNums(subRuleAttr.ruleSubHandleLimitValue, true)"
                  ></el-input>
                  <span>条数，每日奖励上限</span>
                  <el-input
                    v-model="subRuleAttr.pointsGrantLimitValue"
                    @input="subRuleAttr.pointsGrantLimitValue = formatNums(subRuleAttr.pointsGrantLimitValue, true)"
                  ></el-input>
                  <span>积分</span>
                </div>
              </div>
            </div>
            <div class="pad10-t">
              <span>关注</span>
              <span class="f12 gray9 mar30_l">关注对单一被关注者不论关注多少次，积分只能领取一次</span>
              <div v-for="subRuleAttr in ruleDtl.subRuleAttrList" :key="subRuleAttr.ruleSubType">
                <div class="pad10-t pad20-l gray3" v-if="subRuleAttr.ruleSubType === 'GZ_BY_OPERATOR'">
                  <span>被关注者获得</span>
                  <el-input
                    v-model="subRuleAttr.pointsGrantValue"
                    @input="subRuleAttr.pointsGrantValue = formatNums(subRuleAttr.pointsGrantValue, true)"
                  ></el-input>
                  <span>积分，每日奖励上限</span>
                  <el-input
                    v-model="subRuleAttr.ruleSubHandleLimitValue"
                    @input="subRuleAttr.ruleSubHandleLimitValue = formatNums(subRuleAttr.ruleSubHandleLimitValue, true)"
                  ></el-input>
                  <span>人数，每日关注上限</span>
                  <el-input
                    v-model="subRuleAttr.pointsGrantLimitValue"
                    @input="subRuleAttr.pointsGrantLimitValue = formatNums(subRuleAttr.pointsGrantLimitValue, true)"
                  ></el-input>
                  <span>积分</span>
                </div>
              </div>
            </div>
            <div class="pad10-t">
              <span>点赞帖子</span>
              <span class="f12 gray9 mar30_l">点赞者对单一帖子不论点赞多少次，积分只能领取一次</span>
              <div v-for="subRuleAttr in ruleDtl.subRuleAttrList" :key="subRuleAttr.ruleSubType">
                <div class="pad10-t pad20-l gray3" v-if="subRuleAttr.ruleSubType === 'DZ_BY_OPERATOR'">
                  <span>发帖者获得</span>
                  <el-input
                    v-model="subRuleAttr.pointsGrantValue"
                    @input="subRuleAttr.pointsGrantValue = formatNums(subRuleAttr.pointsGrantValue, true)"
                  ></el-input>
                  <span>积分，每日奖励上限</span>
                  <el-input
                    v-model="subRuleAttr.ruleSubHandleLimitValue"
                    @input="subRuleAttr.ruleSubHandleLimitValue = formatNums(subRuleAttr.ruleSubHandleLimitValue, true)"
                  ></el-input>
                  <span>条数，每日奖励上限</span>
                  <el-input
                    v-model="subRuleAttr.pointsGrantLimitValue"
                    @input="subRuleAttr.pointsGrantLimitValue = formatNums(subRuleAttr.pointsGrantLimitValue, true)"
                  ></el-input>
                  <span>积分</span>
                </div>
                <div class="pad10-t pad20-l gray3" v-if="subRuleAttr.ruleSubType === 'DZ_OPERATOR'">
                  <span>点赞者获得</span>
                  <el-input
                    v-model="subRuleAttr.pointsGrantValue"
                    @input="subRuleAttr.pointsGrantValue = formatNums(subRuleAttr.pointsGrantValue, true)"
                  ></el-input>
                  <span>积分，每日奖励上限</span>
                  <el-input
                    v-model="subRuleAttr.ruleSubHandleLimitValue"
                    @input="subRuleAttr.ruleSubHandleLimitValue = formatNums(subRuleAttr.ruleSubHandleLimitValue, true)"
                  ></el-input>
                  <span>条数，每日奖励上限</span>
                  <el-input
                    v-model="subRuleAttr.pointsGrantLimitValue"
                    @input="subRuleAttr.pointsGrantLimitValue = formatNums(subRuleAttr.pointsGrantLimitValue, true)"
                  ></el-input>
                  <span>积分</span>
                </div>
              </div>
            </div>
            <div class="pad10-t">
              <span>评论帖子</span>
              <span class="f12 gray9 mar30_l">评论者对单一帖子不论评论多少次，积分只能领取一次</span>
              <div v-for="subRuleAttr in ruleDtl.subRuleAttrList" :key="subRuleAttr.ruleSubType">
                <div class="pad10-t pad20-l gray3" v-if="subRuleAttr.ruleSubType === 'PL_BY_OPERATOR'">
                  <span>发帖者获得</span>
                  <el-input
                    v-model="subRuleAttr.pointsGrantValue"
                    @input="subRuleAttr.pointsGrantValue = formatNums(subRuleAttr.pointsGrantValue, true)"
                  ></el-input>
                  <span>积分，每日奖励上限</span>
                  <el-input
                    v-model="subRuleAttr.ruleSubHandleLimitValue"
                    @input="subRuleAttr.ruleSubHandleLimitValue = formatNums(subRuleAttr.ruleSubHandleLimitValue, true)"
                  ></el-input>
                  <span>条数，每日奖励上限</span>
                  <el-input
                    v-model="subRuleAttr.pointsGrantLimitValue"
                    @input="subRuleAttr.pointsGrantLimitValue = formatNums(subRuleAttr.pointsGrantLimitValue, true)"
                  ></el-input>
                  <span>积分</span>
                </div>
                <div class="pad10-t pad20-l gray3" v-if="subRuleAttr.ruleSubType === 'PL_OPERATOR'">
                  <span>评论者获得</span>
                  <el-input
                    v-model="subRuleAttr.pointsGrantValue"
                    @input="subRuleAttr.pointsGrantValue = formatNums(subRuleAttr.pointsGrantValue, true)"
                  ></el-input>
                  <span>积分，每日奖励上限</span>
                  <el-input
                    v-model="subRuleAttr.ruleSubHandleLimitValue"
                    @input="subRuleAttr.ruleSubHandleLimitValue = formatNums(subRuleAttr.ruleSubHandleLimitValue, true)"
                  ></el-input>
                  <span>条数，每日奖励上限</span>
                  <el-input
                    v-model="subRuleAttr.pointsGrantLimitValue"
                    @input="subRuleAttr.pointsGrantLimitValue = formatNums(subRuleAttr.pointsGrantLimitValue, true)"
                  ></el-input>
                  <span>积分</span>
                </div>
              </div>
            </div>
          </div>
        </el-radio>
      </el-radio-group>
    </div>
    <div class="box30"></div>
    <div class="t_center" v-if="!ruleDtl.id">
      <el-button class="mar20_r" @click="cancelRuleDtl()">取 消</el-button>
      <el-button type="primary" @click="saveRuleDtl()">确 定</el-button>
    </div>
    <div class="t_center" v-else>
      <el-button class="mar20_r" @click="cancelRuleDtl()">返 回</el-button>
    </div>
    <el-dialog title="选择商品" :visible.sync="chooseGoodVisible" width="800px">
      <div>
        <div class="pad20_b">
          <el-input v-model="searchGoods.name" placeholder="请输入商品名称"></el-input>
          <el-button type="primary" @click="goodSearch">搜 索</el-button>
        </div>
        <el-table :data="goodsDataList" ref="multipleTable" @selection-change="handleSelectionChange" row-key="goodsId" style="width: 100%" height="289">
          <el-table-column type="selection" :reserve-selection="true" width="55"> </el-table-column>
          <el-table-column prop="name" label="商品名称" width="400"> </el-table-column>
          <el-table-column prop="marketPriceStr" width="200" label="价格"> </el-table-column>
          <el-table-column prop="statusName" label="状态"> </el-table-column>
        </el-table>
        <div class="box15"></div>
        <div class="t_right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
            popper-class="seller-style"
          >
          </el-pagination>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="chooseGoodVisible = false">取 消</el-button>
        <el-button type="primary" @click="goodsDialogConfirm">确 定</el-button>
      </span>
    </el-dialog>
    <!--选择客户弹框-->
    <el-dialog
      title="选择客户"
      :visible.sync="customerPop.chooseClientVisible"
      :close-on-click-modal="false"
      width="800px"
      :show-close="false"
      custom-class="chooseClientPop"
    >
      <div>
        <div class="clear ps_search_wrap">
          <span class="float-left pad15_r lin_30 inlineblock" style="padding-right: 25px">客户名称</span>
          <div class="ps_search float-left">
            <el-input type="text" placeholder="请输入客户名称" v-model="customerPop.searchCustomer.name"> </el-input>
          </div>
        </div>
        <div class="clear ps_search_wrap" style="padding-top: 10px">
          <span class="float-left pad15_r lin_30 inlineblock" style="padding-right: 11px">客户手机号</span>
          <div class="ps_search float-left">
            <el-input type="text" placeholder="请输入客户手机号" v-model="customerPop.searchCustomer.phone"> </el-input>
          </div>
          <div class="float-left client_pop_query" @click="listCustomer(1)">搜索</div>
        </div>
        <div class="box30"></div>
        <div class="clear ps_search_wrap">
          <span class="float-left pad15_r lin_30 inlineblock">客户分组</span>
          <div class="ps_search float-left">
            <el-select popper-class="seller-style" v-model="customerPop.searchCustomer.groupId" placeholder="请选择客户分组" clearable>
              <el-option v-for="item in customerPop.groupDataList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </div>
        </div>
        <div class="box20"></div>
        <div class="clear ps_group_list">
          <div class="float-left client_list_all">
            <p>我的客户</p>
            <div class="client_list_pop_main">
              <ul class="clear">
                <!-- 客户-->
                <li v-for="(item, index) in customerPop.customerDataList" :key="index" @click="customerDialogSelect(item)">
                  <div class="client_list_mask" v-if="item.isCheck" v-html="'归属合同模板：' + item.attrName"></div>
                  <p class="group_item_name ellipsis_two">{{ item.name }}</p>
                  <p>身份：{{ item.targetType === 1 ? "个人" : "企业" }}</p>
                </li>
              </ul>
            </div>
          </div>
          <div class="float-right client_list_me">
            <p>已选客户</p>
            <div class="client_list_pop_main">
              <ul class="clear">
                <li v-for="(item, index) in customerPop.customerSelList" :key="index">
                  <i class="iconfont icon-shibai fb" @click="removeSelectCustomer(item)"></i>
                  <p class="group_item_name ellipsis_two">{{ item.name }}</p>
                  <p>身份：{{ item.targetType === 1 ? "个人" : "企业" }}</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="box20"></div>
      <el-pagination
        background
        @size-change="handleSizeChangeCustomer"
        @current-change="handleCurrentChangeCustomer"
        :current-page="customerPop.currentPageCustomer"
        :page-sizes="[10, 20, 30]"
        :page-size="customerPop.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="customerPop.totalCount"
        popper-class="seller-style"
      >
      </el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="customerDialogConfirm">确 认</el-button>
        <el-button @click="customerDialogClose">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      chooseGoodVisible: false,
      goodType: "shop",
      ruleDtl: {
        id: "",
        name: "",
        ruleId: "",
        shopId: "",
        pointsType: "",
        busType: 1,
        busId: "",
        ruleType: 1,
        timeStr: "",
        applyCustomerType: 1,
        applyCustomerAttr: [],
        sbusType: 1,
        startTime: "",
        endTime: "",
        // 累计发放--按消费金额发放规则列表
        subRuleAttrVal: [
          {
            ruleKey: "",
            ruleValue: "",
          },
        ],
        // 社区激励发放规则列表
        subRuleAttrList: [
          {
            ruleType: "FT",
            ruleSubType: "FT_BY_OPERATOR",
            ruleSubHandleLimitValue: 0,
            pointsGrantLimitValue: 0,
            pointsGrantValue: 0,
          },
          {
            ruleType: "GZ",
            ruleSubType: "GZ_BY_OPERATOR",
            ruleSubHandleLimitValue: 0,
            pointsGrantLimitValue: 0,
            pointsGrantValue: 0,
          },
          {
            ruleType: "DZ",
            ruleSubType: "DZ_BY_OPERATOR",
            ruleSubHandleLimitValue: 0,
            pointsGrantLimitValue: 0,
            pointsGrantValue: 0,
          },
          {
            ruleType: "DZ",
            ruleSubType: "DZ_OPERATOR",
            ruleSubHandleLimitValue: 0,
            pointsGrantLimitValue: 0,
            pointsGrantValue: 0,
          },
          {
            ruleType: "PL",
            ruleSubType: "PL_BY_OPERATOR",
            ruleSubHandleLimitValue: 0,
            pointsGrantLimitValue: 0,
            pointsGrantValue: 0,
          },
          {
            ruleType: "PL",
            ruleSubType: "PL_OPERATOR",
            ruleSubHandleLimitValue: 0,
            pointsGrantLimitValue: 0,
            pointsGrantValue: 0,
          },
        ],
        subRuleAttr: [],

        ruleKey: "",
        ruleValue: "",
        ruleKey1: "",
        ruleValue1: "",
        ruleKey2: "",
        ruleValue2: "",
        ruleKey3: "",
        ruleValue3: "",
        ruleKey4: "",
        ruleValue4: "",

        goodType: 1,
        goodRuleType: 1,
        goodRuleKey: "",
        goodRuleValue: "",
        goodRuleKey1: "",
        goodRuleValue1: "",
        goodRuleKey2: "",
        goodRuleValue2: "",
        goodRuleKey3: "",
        goodRuleValue3: "",
      },
      multipleSelection: [],
      pageSize: 10, // 商品列表页分页大小
      currentPage: 1, // 商品列表页当前分页
      totalCount: 0, // 商品列表页商品总数
      goodsDataList: [], // 店铺商品列表
      checkGoodsList: [], // 选择的商品
      searchGoods: {
        name: "",
        axis: "",
        pageNum: 1,
        pageSize: 10,
        // isoa: 0,
        status: "-1",
      },
      checkList: [],
      customerPop: {
        chooseClientVisible: false,
        searchCustomer: {
          name: "",
          phone: "",
          groupId: "",
          pageNum: 1,
          pageSize: 10,
        },
        customerDataList: [],
        customerSelList: [],
        currentPageCustomer: 1,
        groupDataList: [],
        pageSize: 10,
        totalCount: 0,
      },
    };
  },
  computed: mapState({
    userInfo: (state) => state.app.userInfo,
  }),
  created() {
    this.$set(this.ruleDtl, "id", this.$route.query.id);
    this.$set(this.ruleDtl, "ruleId", this.$route.query.ruleId);
    this.$set(this.ruleDtl, "shopId", this.$route.query.shopId);
    this.$set(this.ruleDtl, "pointsType", this.$route.query.pointsType);
    this.$set(this.ruleDtl, "name", this.$route.query.name);
    this.getPointsRuleDtl();
    this.getCustomerGroupList();
  },
  mounted() {},
  // 监听器
  filters: {},
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      if (this.goodType === "dealer") {
        this.listDealerGoods();
      } else {
        this.listShopGoods();
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      if (this.goodType === "dealer") {
        this.listDealerGoods();
      } else {
        this.listShopGoods();
      }
    },
    toggleSelection(rows) {
      if (!this.$refs.multipleTable) {
        return;
      }
      this.$refs.multipleTable.clearSelection();
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row, true);
        });
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 点击添加货品
    selectGoodsList(type) {
      this.chooseGoodVisible = true;
      this.goodType = type;
      this.goodsDataList = [];
      this.totalCount = 0;
      if (type === "dealer") {
        this.listDealerGoods();
      } else {
        this.listShopGoods();
      }
    },
    goodSearch() {
      if (this.goodType === "dealer") {
        this.listDealerGoods();
      } else {
        this.listShopGoods();
      }
    },
    // 查询店铺全部在售非oa商品
    listShopGoods() {
      this.searchGoods.pageNum = this.currentPage;
      this.searchGoods.pageSize = this.pageSize;
      this.$store.dispatch("goods/goods/getShopGoodsList", this.searchGoods).then((data) => {
        if (data) {
          this.goodsDataList = data.goodsList;
          this.totalCount = data.totalCount;
          this.toggleSelection(this.checkGoodsList);
        }
      });
    },
    // 查询代销商品
    listDealerGoods() {
      this.searchGoods.pageNum = this.currentPage;
      this.searchGoods.pageSize = this.pageSize;
      this.$store.dispatch("goods/goods/getDealershipsList", this.searchGoods).then((data) => {
        console.log("代销商品", data);
        if (data) {
          this.goodsDataList = data.list;
          this.totalCount = data.totalCount;
          this.toggleSelection(this.checkGoodsList);
        }
      });
    },
    // 确定选择商品
    goodsDialogConfirm() {
      this.checkGoodsList = [];
      this.multipleSelection.forEach((goods) => {
        this.checkGoodsList.push(goods);
      });
      this.chooseGoodVisible = false;
    },
    // 删除已选中商品
    removeCheckGoods(goodsId) {
      this.checkGoodsList.splice(
        this.checkGoodsList.findIndex((item) => item.goodsId === goodsId),
        1
      );
      this.toggleSelection(this.checkGoodsList);
    },
    // 查询店铺分类
    listShopCategory() {
      this.$store.dispatch("shop/shop/getCategoryFirstList").then((data) => {
        this.categoryDataList = data;
      });
    },
    clearRule() {},
    busTypeChange(busType) {
      if (busType === 2) {
        this.$set(this.ruleDtl, "ruleType", "");
      }
      console.info(busType);
    },
    ruleTypeChange(ruleType) {
      console.info(ruleType);
    },
    cancelRuleDtl() {
      this.$router.push("/mj/pointsList");
    },
    getPointsRuleDtl() {
      if (!this.ruleDtl.id) {
        return;
      }
      const params = { id: this.ruleDtl.id, shopId: this.ruleDtl.shopId };
      this.$store.dispatch("points/points/getPointsRuleDtl", this.$qs.stringify(params)).then((data) => {
        if (!data) {
          return;
        }
        const ruleDtl = {
          id: data.id,
          ruleId: data.ruleId,
          pointsType: data.pointsType,
          busType: data.busType,
          timeStr: [data.startTime, data.endTime],
          applyCustomerType: data.applyCustomerType,
          applyCustomerAttr: eval(data.applyCustomerAttr),
          sbusType: data.sbusType,
          subRuleAttrVal: eval(data.subRuleAttr),
          subRuleAttrList: data.yxPointsSubRuleAttrList || [],
          shopId: this.ruleDtl.shopId,
        };
        if (ruleDtl.applyCustomerType === 3) {
          ruleDtl.applyCustomerAttr = [];
          this.customerPop.customerSelList = data.customerEntityResList;
        }
        // 1订单 2商品 4评论
        if (data.busType === 1) {
          ruleDtl.ruleType = data.ruleType;
          ruleDtl[`ruleKey${data.ruleType}`] = data.ruleKey;
          ruleDtl[`ruleValue${data.ruleType}`] = data.ruleValue;
        }
        if (data.busType === 4) {
          ruleDtl.ruleType = data.ruleType;
          ruleDtl[`ruleKey4`] = data.ruleKey;
          ruleDtl[`ruleValue4`] = data.ruleValue;
        }
        if (data.busType === 2 || data.busType === 5) {
          ruleDtl.goodRuleType = data.ruleType;
          ruleDtl[`goodRuleKey${data.ruleType}`] = data.ruleKey;
          ruleDtl[`goodRuleValue${data.ruleType}`] = data.ruleValue;
          ruleDtl.goodType = 1;
          if (data.busId && JSON.parse(data.busId).length > 0) {
            ruleDtl.goodType = 2;
          }
        }
        this.checkGoodsList = data.goodsList || [];
        this.ruleDtl = ruleDtl;
        this.$set(this.ruleDtl, "name", this.$route.query.name);
      });
    },
    saveRuleDtl() {
      const ruleDtl = Object.assign({}, this.ruleDtl);
      if (ruleDtl.applyCustomerType !== 1 && ruleDtl.applyCustomerAttr.length === 0) {
        this.$message.error("请选择应用客户范围");
        return;
      }
      let ruleKey = "";
      let ruleValue = "";
      const goodsIdList = [];
      // 1订单 2商品 4评论
      if (ruleDtl.busType === 1) {
        // 1按固定数量 2按金额 3按比例
        ruleKey = ruleDtl[`ruleKey${ruleDtl.ruleType}`];
        ruleValue = ruleDtl[`ruleValue${ruleDtl.ruleType}`];
      }
      if (ruleDtl.busType === 4) {
        ruleKey = ruleDtl[`ruleKey4`];
        ruleValue = ruleDtl[`ruleValue4`];
      }
      if (ruleDtl.busType === 2 || ruleDtl.busType === 5) {
        ruleDtl.ruleType = ruleDtl.goodRuleType;
        ruleKey = ruleDtl[`goodRuleKey${ruleDtl.ruleType}`];
        ruleValue = ruleDtl[`goodRuleValue${ruleDtl.ruleType}`];
        this.checkGoodsList.forEach((goods) => {
          goodsIdList.push(goods.goodsId);
        });
      }
      if (ruleDtl.ruleType === 3 && ruleValue) {
        ruleKey = ruleValue;
      }
      ruleDtl.ruleKey = ruleKey;
      ruleDtl.ruleValue = ruleValue;
      ruleDtl.busId = JSON.stringify(goodsIdList);
      if (ruleDtl.busType !== 5 && ruleDtl.busType !== 6) {
        // 校验参数
        if (!ruleDtl.ruleKey || !ruleDtl.ruleValue) {
          this.$message.error("请输入规则值");
          return;
        }
      } else if (ruleDtl.busType !== 6) {
        if (ruleDtl.timeStr == "") {
          this.$message.error("请输入时间范围");
          return;
        }
        ruleDtl.startTime = ruleDtl.timeStr[0];
        ruleDtl.endTime = ruleDtl.timeStr[1];
        var flag = true;
        ruleDtl.subRuleAttrVal.forEach(function (e, e_index) {
          if (e.ruleKey === "" || e.ruleValue === "") {
            flag = false;
          }
          ruleDtl.subRuleAttrVal.forEach(function (attr, attr_index) {
            if (Number(e.ruleKey) === Number(attr.ruleKey) && e_index !== attr_index) {
              flag = false;
            }
          });
        });
        if (!flag) {
          this.$message.error("规则值为空或者重复");
          throw new Error("EndIterative");
        }
        ruleDtl.subRuleAttr = JSON.stringify(ruleDtl.subRuleAttrVal);
      }
      if (ruleDtl.busType === 6) {
        if (ruleDtl.timeStr == "") {
          this.$message.error("请输入时间范围");
          return;
        }
        ruleDtl.startTime = ruleDtl.timeStr[0];
        ruleDtl.endTime = ruleDtl.timeStr[1];
        var subRuleAttrFlag = true;
        ruleDtl.subRuleAttrList.forEach(function (e) {
          if (e.ruleSubHandleLimitValue === "" || e.pointsGrantLimitValue === "" || e.pointsGrantValue === "") {
            subRuleAttrFlag = false;
          }
        });
        if (!subRuleAttrFlag) {
          this.$message.error("规则值为空");
          throw new Error("EndIterative");
        }
        ruleDtl.subRuleAttr = JSON.stringify(ruleDtl.subRuleAttrList);
      }
      // 指定商品
      if (ruleDtl.goodType === 2 && goodsIdList.length === 0) {
        this.$message.error("请选择商品");
        return;
      }
      this.$store.dispatch("points/points/addOrModifyRuleDtl", ruleDtl).then((data) => {
        if (data.code !== "0") {
          this.$message.error(data.msg);
          return;
        }
        this.cancelRuleDtl();
      });
    },
    // num 输入的数字 decimal 小数 true false
    formatNums(nums, decimal) {
      let value = `${nums}`;
      value = value.replace(/[^\d.]/g, "");
      value = value.replace(/\.{2,}/g, ".");
      value = value.replace(".", "$#$");
      value = value.replace(/\./g, "");
      value = value.replace("$#$", ".");
      const reg = new RegExp("^(-)?(\\d{1,8})\\.(\\d{0,4}).*$");
      value = value.replace(reg, "$1$2.$3");
      if (value.indexOf(".") < 0 && value !== "" && value !== "-") {
        // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        value = parseFloat(value);
      }
      if (value && !decimal) {
        value = parseInt(value, 10);
      }
      return value;
    },
    openCustomerPop() {
      this.customerPop.currentPageCustomer = 1;
      this.customerPop.chooseClientVisible = true;
      this.listCustomer(1);
    },
    handleSizeChangeCustomer(val) {
      this.customerPop.pageSize = val;
      this.listCustomer();
    },
    handleCurrentChangeCustomer(val) {
      this.customerPop.currentPageCustomer = val;
      this.listCustomer();
    },
    customerDialogClose() {
      this.customerPop.chooseClientVisible = false;
    },
    getCustomerGroupList() {
      const param = { shopId: this.ruleDtl.shopId };
      console.log(param);
      this.$store.dispatch("shop/shop/getCustomerGroupList").then((data) => {
        this.customerPop.groupDataList = [];
        if (data) {
          this.customerPop.groupDataList = data;
        }
      });
    },
    listCustomer(type) {
      const { searchCustomer } = this.customerPop;
      searchCustomer.pageNum = this.customerPop.currentPageCustomer;
      searchCustomer.pageSize = this.customerPop.pageSize;
      if (type === 1) {
        searchCustomer.pageNum = 1;
      }
      this.$store.dispatch("shop/shop/listCustomer", this.$qs.stringify(searchCustomer)).then((data) => {
        const newData = data || {};
        this.customerPop.customerDataList = newData.data || [];
        this.customerPop.totalCount = newData.count || 0;
        if (this.customerPop.customerDataList.length > 0 && this.customerPop.customerSelList.length > 0) {
          this.customerPop.customerDataList.forEach((item) => {
            this.$set(item, "isCheck", false);
            this.customerPop.customerSelList.forEach((customer) => {
              if (item.targetIdStr == customer.customerIdStr) {
                // eslint-disable-line
                item.isCheck = true;
              }
            });
          });
        }
        if (type === 2) {
          if (this.customerPop.customerDataList.length === 0) {
            this.$message.error("无客户数据,请添加客户");
            return;
          }
          this.customerPop.chooseClientVisible = true;
        }
      });
    },
    customerDialogSelect(item) {
      if (item.isCheck) {
        return;
      }
      if (this.customerPop.customerSelList.some((e) => e.id === item.id)) {
        console.log(1);
      } else {
        this.ruleDtl.applyCustomerAttr.push(item.targetIdStr);
        this.customerPop.customerSelList.push(item);
      }
    },
    removeSelectCustomer(item) {
      this.ruleDtl.applyCustomerAttr.splice(this.ruleDtl.applyCustomerAttr.indexOf(item.targetIdStr), 1);
      this.customerPop.customerSelList.splice(this.customerPop.customerSelList.indexOf(item), 1);
    },
    customerDialogConfirm() {
      this.customerPop.chooseClientVisible = false;
    },
    addsubRuleAttrVal() {
      let ruleAttr = {
        ruleKey: "",
        ruleValue: "",
      };
      this.ruleDtl.subRuleAttrVal.push(ruleAttr);
    },
    delsubRuleAttrVal(item) {
      this.ruleDtl.subRuleAttrVal.splice(this.ruleDtl.subRuleAttrVal.indexOf(item), 1);
    },
    getCustomerType() {
      this.ruleDtl.applyCustomerAttr = [];
      this.customerPop.customerSelList = [];
    },
  },
};
</script>

<style lang="scss" scoped>
@import "index";
</style>
